export default __webpack_public_path__ + "static/media/Robes of a Thousand Blossoms.3219b2d5.jpg";